var _clipPath, _clipPath2, _clipPath3, _clipPath4, _clipPath5, _clipPath6, _clipPath7, _clipPath8, _clipPath9, _clipPath0, _clipPath1, _clipPath10, _clipPath11, _clipPath12, _linearGradient, _linearGradient2, _linearGradient3, _linearGradient4, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g0;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDown(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 26 19",
    id: "svg1229",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", {
    id: "defs1223"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient54",
    spreadMethod: "pad",
    gradientTransform: "matrix(0,52.356018,-52.356018,0,37.984501,2.223999)",
    gradientUnits: "userSpaceOnUse",
    y2: 0,
    x2: 1,
    y1: 0,
    x1: 0
  }, /*#__PURE__*/React.createElement("stop", {
    id: "stop44-9",
    offset: 0,
    style: {
      stopOpacity: 1,
      stopColor: "#ffffff"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    id: "stop46-9",
    offset: 0.127,
    style: {
      stopOpacity: 1,
      stopColor: "#ffffff"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    id: "stop48",
    offset: 0.267,
    style: {
      stopOpacity: 0.15999084,
      stopColor: "#ffffff"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    id: "stop50",
    offset: 0.539,
    style: {
      stopOpacity: 0,
      stopColor: "#ffffff"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    id: "stop52",
    offset: 1,
    style: {
      stopOpacity: 0,
      stopColor: "#ffffff"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient78",
    spreadMethod: "pad",
    gradientTransform: "matrix(0,52.356018,-52.356018,0,37.984501,2.223999)",
    gradientUnits: "userSpaceOnUse",
    y2: 0,
    x2: 1,
    y1: 0,
    x1: 0
  }, /*#__PURE__*/React.createElement("stop", {
    id: "stop68",
    offset: 0,
    style: {
      stopOpacity: 1,
      stopColor: "#7affff"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    id: "stop70",
    offset: 0.127,
    style: {
      stopOpacity: 1,
      stopColor: "#7affff"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    id: "stop72",
    offset: 0.267,
    style: {
      stopOpacity: 1,
      stopColor: "#7affff"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    id: "stop74",
    offset: 0.539,
    style: {
      stopOpacity: 1,
      stopColor: "#7affff"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    id: "stop76",
    offset: 1,
    style: {
      stopOpacity: 1,
      stopColor: "#7affff"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient118",
    spreadMethod: "pad",
    gradientTransform: "matrix(-5.4759989,-24.301025,24.301025,-5.4759989,42.786262,66.061951)",
    gradientUnits: "userSpaceOnUse",
    y2: 0,
    x2: 1,
    y1: 0,
    x1: 0
  }, /*#__PURE__*/React.createElement("stop", {
    id: "stop114",
    offset: 0,
    style: {
      stopOpacity: 1,
      stopColor: "#ffffff"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    id: "stop116-1",
    offset: 1,
    style: {
      stopOpacity: 0.17000076,
      stopColor: "#ffffff"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient136",
    spreadMethod: "pad",
    gradientTransform: "matrix(-5.4759989,-24.301025,24.301025,-5.4759989,42.786262,66.061951)",
    gradientUnits: "userSpaceOnUse",
    y2: 0,
    x2: 1,
    y1: 0,
    x1: 0
  }, /*#__PURE__*/React.createElement("stop", {
    id: "stop132",
    offset: 0,
    style: {
      stopOpacity: 1,
      stopColor: "#7affff"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    id: "stop134",
    offset: 1,
    style: {
      stopOpacity: 1,
      stopColor: "#7affff"
    }
  })), _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath18-4-2",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path16-18-8",
    d: "M 0,66 H 76 V 0 H 0 Z"
  }))), _clipPath2 || (_clipPath2 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath34-2-5",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path32-1-3",
    d: "M 2.472,63.506 H 73.497 V 2.341 H 2.472 Z"
  }))), _clipPath3 || (_clipPath3 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath38-6-9",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path36-0-5",
    d: "m 9.727,2.341 c -3.797,0 -7.255,3.203 -7.255,6.722 0,0 0.013,5.812 0.013,9.332 0,0.184 0.004,0.342 0.008,0.485 0.973,-1.427 2.396,-2.208 4.232,-2.319 0.115,-0.008 0.227,-0.011 0.333,-0.011 1.663,0 2.601,0.82 3.419,1.658 1.7,1.739 1.713,3.976 1.778,14.709 C 12.19,43.666 12.177,45.901 10.477,47.641 9.658,48.479 8.721,49.3 7.058,49.3 6.952,49.3 6.84,49.296 6.725,49.29 4.887,49.177 3.465,48.395 2.493,46.97 c -0.005,0.162 -0.008,0.323 -0.008,0.485 0,3.521 -0.013,9.332 -0.013,9.332 0,3.516 3.458,6.719 7.255,6.719 h 47.546 c 3.623,0 6.572,-3.016 6.572,-6.719 0.032,-3.298 0.104,-9.558 0.106,-9.749 0,-3.157 0.979,-4.504 3.276,-4.504 1.769,0 2.479,1.093 3,1.893 0.476,0.732 0.737,1.135 1.692,1.135 1.545,0 1.554,-5.079 1.567,-10.454 0,-0.675 0.011,-2.283 0.011,-2.283 -0.008,-0.71 -0.011,-1.409 -0.011,-2.085 -0.016,-5.374 -0.022,-10.453 -1.567,-10.453 -0.955,0 -1.219,0.404 -1.692,1.135 -0.521,0.803 -1.231,1.895 -3,1.895 -2.299,0 -3.276,-1.348 -3.276,-4.506 -0.002,-0.188 -0.074,-6.449 -0.106,-9.734 0,-3.719 -2.949,-6.732 -6.572,-6.732 H 9.727 Z"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask56-1-0",
    height: 1,
    width: 1,
    y: 0,
    x: 0,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g66-6-8"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g64-06-8"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g62-6-5"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g60-7-6"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path58-03-9",
    style: {
      fill: "url(#linearGradient54)",
      stroke: "none"
    },
    d: "M -32768,32767 H 32767 V -32768 H -32768 Z"
  })))))), _clipPath4 || (_clipPath4 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath104-3-5",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path102-57-8",
    d: "m 2.472,63.508 h 71.03 V 30.7882 H 2.472 Z"
  }))), _clipPath5 || (_clipPath5 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath108-8-5",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path106-8-5",
    d: "m 2.492,46.97 c 0.973,1.426 2.395,2.207 4.232,2.32 0.115,0.006 0.227,0.01 0.333,0.01 1.663,0 2.601,-0.82 3.419,-1.659 1.607,-1.645 1.707,-6.122 1.768,-15.423 18.04,-4.051 26.213,1.793 45.277,1.793 11.387,0 8.021,-0.692 15.975,-1.907 0.004,0.244 0.004,0.478 0.006,0.723 0,0 -0.01,1.608 -0.01,2.283 -0.016,5.375 -0.023,10.454 -1.568,10.454 -0.955,0 -1.219,-0.402 -1.693,-1.135 -0.521,-0.8 -1.23,-1.893 -3,-1.893 -2.299,0 -3.275,1.347 -3.275,4.504 -0.002,0.191 -0.074,6.451 -0.105,9.749 0,3.703 -2.949,6.719 -6.572,6.719 H 9.727 c -3.797,0 -7.255,-3.203 -7.255,-6.719 0,0 0.013,-5.811 0.013,-9.332 -10e-4,-0.185 0.003,-0.345 0.007,-0.487"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask120-1-7",
    height: 1,
    width: 1,
    y: 0,
    x: 0,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g130-7-3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g128-25-7"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g126-80-8"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g124-7-1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path122-80-9",
    style: {
      fill: "url(#linearGradient118)",
      stroke: "none"
    },
    d: "M -32768,32767 H 32767 V -32768 H -32768 Z"
  })))))), _clipPath6 || (_clipPath6 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath162-8-6",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path160-9-8",
    d: "M 2.472,63.506 H 73.497 V 9.01401 H 2.472 Z"
  }))), _clipPath7 || (_clipPath7 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath178-1-6",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path176-2-8",
    d: "M 0,66 H 76 V 0 H 0 Z"
  }))), _clipPath8 || (_clipPath8 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath18-7-5",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path16-1-1",
    d: "M 0,66 H 76 V 0 H 0 Z"
  }))), _clipPath9 || (_clipPath9 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath34-1",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path32-0-3",
    d: "M 2.472,63.506 H 73.497 V 2.341 H 2.472 Z"
  }))), _clipPath0 || (_clipPath0 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath38-8",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path36-8",
    d: "m 9.727,2.341 c -3.797,0 -7.255,3.203 -7.255,6.722 0,0 0.013,5.812 0.013,9.332 0,0.184 0.004,0.342 0.008,0.485 0.973,-1.427 2.396,-2.208 4.232,-2.319 0.115,-0.008 0.227,-0.011 0.333,-0.011 1.663,0 2.601,0.82 3.419,1.658 1.7,1.739 1.713,3.976 1.778,14.709 C 12.19,43.666 12.177,45.901 10.477,47.641 9.658,48.479 8.721,49.3 7.058,49.3 6.952,49.3 6.84,49.296 6.725,49.29 4.887,49.177 3.465,48.395 2.493,46.97 c -0.005,0.162 -0.008,0.323 -0.008,0.485 0,3.521 -0.013,9.332 -0.013,9.332 0,3.516 3.458,6.719 7.255,6.719 h 47.546 c 3.623,0 6.572,-3.016 6.572,-6.719 0.032,-3.298 0.104,-9.558 0.106,-9.749 0,-3.157 0.979,-4.504 3.276,-4.504 1.769,0 2.479,1.093 3,1.893 0.476,0.732 0.737,1.135 1.692,1.135 1.545,0 1.554,-5.079 1.567,-10.454 0,-0.675 0.011,-2.283 0.011,-2.283 -0.008,-0.71 -0.011,-1.409 -0.011,-2.085 -0.016,-5.374 -0.022,-10.453 -1.567,-10.453 -0.955,0 -1.219,0.404 -1.692,1.135 -0.521,0.803 -1.231,1.895 -3,1.895 -2.299,0 -3.276,-1.348 -3.276,-4.506 -0.002,-0.188 -0.074,-6.449 -0.106,-9.734 0,-3.719 -2.949,-6.732 -6.572,-6.732 H 9.727 Z"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask56-2",
    height: 1,
    width: 1,
    y: 0,
    x: 0,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g66-63"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g64-3-4"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g62-0"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g60-17-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path58-4-4",
    style: {
      fill: "url(#linearGradient54)",
      stroke: "none"
    },
    d: "M -32768,32767 H 32767 V -32768 H -32768 Z"
  })))))), _clipPath1 || (_clipPath1 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath104-2",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path102-5-2",
    d: "m 2.472,63.508 h 71.03 V 30.7882 H 2.472 Z"
  }))), _clipPath10 || (_clipPath10 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath108-3",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path106-1-1",
    d: "m 2.492,46.97 c 0.973,1.426 2.395,2.207 4.232,2.32 0.115,0.006 0.227,0.01 0.333,0.01 1.663,0 2.601,-0.82 3.419,-1.659 1.607,-1.645 1.707,-6.122 1.768,-15.423 18.04,-4.051 26.213,1.793 45.277,1.793 11.387,0 8.021,-0.692 15.975,-1.907 0.004,0.244 0.004,0.478 0.006,0.723 0,0 -0.01,1.608 -0.01,2.283 -0.016,5.375 -0.023,10.454 -1.568,10.454 -0.955,0 -1.219,-0.402 -1.693,-1.135 -0.521,-0.8 -1.23,-1.893 -3,-1.893 -2.299,0 -3.275,1.347 -3.275,4.504 -0.002,0.191 -0.074,6.451 -0.105,9.749 0,3.703 -2.949,6.719 -6.572,6.719 H 9.727 c -3.797,0 -7.255,-3.203 -7.255,-6.719 0,0 0.013,-5.811 0.013,-9.332 -10e-4,-0.185 0.003,-0.345 0.007,-0.487"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask120-63",
    height: 1,
    width: 1,
    y: 0,
    x: 0,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g130-4"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g128-2-4"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g126-8-0"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g124-2-0"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path122-2-5",
    style: {
      fill: "url(#linearGradient118)",
      stroke: "none"
    },
    d: "M -32768,32767 H 32767 V -32768 H -32768 Z"
  })))))), _clipPath11 || (_clipPath11 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath162-00-1",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path160-3-0",
    d: "M 2.472,63.506 H 73.497 V 9.01401 H 2.472 Z"
  }))), _clipPath12 || (_clipPath12 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath178-4",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path176-9",
    d: "M 0,66 H 76 V 0 H 0 Z"
  }))), _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#linearGradient78",
    id: "linearGradient21255",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(0,52.356018,-52.356018,0,37.984501,2.223999)",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    spreadMethod: "pad"
  })), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#linearGradient136",
    id: "linearGradient21257",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(-5.4759989,-24.301025,24.301025,-5.4759989,42.786262,66.061951)",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    spreadMethod: "pad"
  })), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#linearGradient78",
    id: "linearGradient21259",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(0,52.356018,-52.356018,0,37.984501,2.223999)",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    spreadMethod: "pad"
  })), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#linearGradient136",
    id: "linearGradient21261",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(-5.4759989,-24.301025,24.301025,-5.4759989,42.786262,66.061951)",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    spreadMethod: "pad"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "layer1",
    transform: "translate(-94.470397,-306.48848)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g21731",
    transform: "translate(-329.93503,18.111468)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g20675-4",
    transform: "translate(21.886095,5.1220421)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.3023652,0,0,-0.3023652,374.5959,309.57717)",
    id: "g10-8-1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g12-2-0"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipPath18-4-2)",
    id: "g14-6-0"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(9.727,0.85)",
    id: "g20-29-5"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path22-7-7",
    style: {
      fill: "#43d3ff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 0,0 c -4.649,0 -8.727,3.838 -8.727,8.212 0,0 0.013,5.81 0.013,9.332 0,1.348 0.13,2.725 1.092,2.725 0.555,0 1.033,-0.544 1.58,-1.36 0.712,-1.062 1.736,-1.622 3.13,-1.71 0.083,-0.005 0.163,-0.008 0.242,-0.008 1.003,0 1.587,0.41 2.375,1.217 1.233,1.264 1.289,3.469 1.352,13.67 -0.063,10.194 -0.119,12.397 -1.352,13.662 -0.788,0.807 -1.372,1.217 -2.375,1.217 -0.078,0 -0.159,-0.003 -0.242,-0.008 -1.393,-0.086 -2.416,-0.645 -3.129,-1.708 -0.547,-0.817 -1.025,-1.362 -1.58,-1.362 -0.962,0 -1.092,1.378 -1.092,2.726 -0.001,3.52 -0.014,9.331 -0.014,9.331 0,4.376 4.078,8.214 8.727,8.214 h 47.546 c 4.435,0 8.041,-3.684 8.041,-8.213 0,0 0.104,-9.542 0.104,-9.749 0,-3.01 0.921,-3.01 1.812,-3.01 0.979,0 1.312,0.513 1.772,1.224 0.522,0.804 1.177,1.804 2.92,1.804 3.011,0 3.021,-4.752 3.039,-11.946 l 0.009,-2.285 -0.009,-2.084 c -0.019,-7.195 -0.028,-11.948 -3.039,-11.948 -1.743,0 -2.396,1.001 -2.92,1.807 -0.462,0.711 -0.796,1.226 -1.772,1.226 -0.891,0 -1.812,0 -1.812,-3.015 0,-0.207 -0.104,-9.752 -0.104,-9.752 C 55.587,3.687 51.981,0 47.546,0 47.546,0 0,0 0,0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(57.273,65.5)",
    id: "g24-0-0"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path26-8-2",
    style: {
      fill: "#308ba0",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 0,0 h -47.546 c -4.915,0 -9.227,-4.071 -9.227,-8.713 0,-0.002 0.013,-5.812 0.013,-9.332 0,-0.965 0,-3.226 1.592,-3.226 0.863,0 1.483,0.818 1.996,1.584 0.395,0.589 1.11,1.385 2.744,1.486 0.073,0.004 0.143,0.007 0.211,0.007 0.835,0 1.297,-0.329 2.018,-1.067 1.097,-1.125 1.148,-3.288 1.209,-13.321 -0.062,-10.023 -0.113,-12.188 -1.21,-13.312 -0.719,-0.734 -1.181,-1.063 -2.017,-1.063 -0.069,0 -0.139,0.002 -0.212,0.007 -1.634,0.1 -2.348,0.897 -2.744,1.487 -0.513,0.766 -1.132,1.582 -1.995,1.582 -0.305,0 -1.05,-0.115 -1.379,-1.188 -0.144,-0.472 -0.213,-1.138 -0.213,-2.037 0,-3.521 -0.013,-9.33 -0.013,-9.33 0,-4.646 4.312,-8.717 9.227,-8.717 H 0 c 4.711,0 8.541,3.908 8.541,8.715 0.004,0.379 0.104,9.537 0.104,9.746 0,2.514 0.552,2.514 1.312,2.514 0.672,0 0.873,-0.256 1.354,-0.997 0.525,-0.81 1.322,-2.033 3.339,-2.033 3.509,0 3.521,4.951 3.539,12.446 0.002,0.674 0.004,1.367 0.009,2.08 v 0.206 c -0.005,0.719 -0.007,1.413 -0.009,2.086 -0.021,7.494 -0.03,12.445 -3.539,12.445 -2.017,0 -2.812,-1.222 -3.339,-2.031 -0.48,-0.74 -0.684,-0.996 -1.354,-0.996 -0.76,0 -1.312,0 -1.312,2.51 0,0.21 -0.103,9.37 -0.104,9.76 C 8.541,-3.909 4.709,0 0,0 m 0,-1 c 4.166,0 7.541,-3.454 7.541,-7.713 0,0 0.104,-9.542 0.104,-9.749 0,-3.113 0.979,-3.51 2.312,-3.51 2.566,0 1.824,3.027 4.691,3.027 2.762,0 2.5,-5.62 2.549,-13.531 v -0.201 c -0.049,-7.909 0.213,-13.532 -2.549,-13.532 -2.867,0 -2.125,3.029 -4.691,3.029 -1.332,0 -2.312,-0.399 -2.312,-3.512 0,-0.207 -0.104,-9.748 -0.104,-9.748 0,-4.263 -3.375,-7.713 -7.541,-7.713 h -47.546 c -4.164,0 -8.227,3.45 -8.227,7.713 0,0 0.013,5.811 0.013,9.332 0,1.685 0.255,2.226 0.592,2.226 0.365,0 0.826,-0.634 1.165,-1.14 0.586,-0.873 1.588,-1.81 3.514,-1.932 0.094,-0.006 0.185,-0.009 0.273,-0.009 1.241,0 1.944,0.562 2.732,1.367 1.385,1.42 1.43,3.54 1.494,14.017 -0.064,10.479 -0.109,12.598 -1.494,14.017 -0.789,0.809 -1.491,1.369 -2.733,1.369 -0.088,0 -0.179,-0.003 -0.273,-0.009 -1.926,-0.119 -2.928,-1.055 -3.514,-1.928 -0.339,-0.507 -0.8,-1.141 -1.165,-1.141 -0.337,0 -0.592,0.542 -0.592,2.226 0,3.521 -0.013,9.332 -0.013,9.332 10e-4,4.259 4.063,7.713 8.228,7.713 L 0,-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g28-6-0"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "g30-6-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g96-4-8"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.199997
    },
    id: "g94-3-3",
    clipPath: "url(#clipPath34-2-5)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g92-2-9"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g90-00-7",
    clipPath: "url(#clipPath38-6-9)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g88-5-9"
  }, _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "g80-26-0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g86-2-3",
    mask: "url(#mask56-1-0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g84-4-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path82-12-4",
    style: {
      fill: "url(#linearGradient21255)",
      stroke: "none"
    },
    d: "m 9.727,2.341 c -3.797,0 -7.255,3.203 -7.255,6.722 0,0 0.013,5.812 0.013,9.332 0,0.184 0.004,0.342 0.008,0.485 0.973,-1.427 2.396,-2.208 4.232,-2.319 0.115,-0.008 0.227,-0.011 0.333,-0.011 1.663,0 2.601,0.82 3.419,1.658 1.7,1.739 1.713,3.976 1.778,14.709 C 12.19,43.666 12.177,45.901 10.477,47.641 9.658,48.479 8.721,49.3 7.058,49.3 6.952,49.3 6.84,49.296 6.725,49.29 4.887,49.177 3.465,48.395 2.493,46.97 c -0.005,0.162 -0.008,0.323 -0.008,0.485 0,3.521 -0.013,9.332 -0.013,9.332 0,3.516 3.458,6.719 7.255,6.719 h 47.546 c 3.623,0 6.572,-3.016 6.572,-6.719 0.032,-3.298 0.104,-9.558 0.106,-9.749 0,-3.157 0.979,-4.504 3.276,-4.504 1.769,0 2.479,1.093 3,1.893 0.476,0.732 0.737,1.135 1.692,1.135 1.545,0 1.554,-5.079 1.567,-10.454 0,-0.675 0.011,-2.283 0.011,-2.283 -0.008,-0.71 -0.011,-1.409 -0.011,-2.085 -0.016,-5.374 -0.022,-10.453 -1.567,-10.453 -0.955,0 -1.219,0.404 -1.692,1.135 -0.521,0.803 -1.231,1.895 -3,1.895 -2.299,0 -3.276,-1.348 -3.276,-4.506 -0.002,-0.188 -0.074,-6.449 -0.106,-9.734 0,-3.719 -2.949,-6.732 -6.572,-6.732 H 9.727 Z"
  }))))))))), /*#__PURE__*/React.createElement("g", {
    id: "g98-7-4"
  }, _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "g100-41-5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g154-9-1"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.75
    },
    id: "g152-54-1",
    clipPath: "url(#clipPath104-3-5)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g150-8-9"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g148-3-8",
    clipPath: "url(#clipPath108-8-5)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g146-2-9"
  }, _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "g138-50-5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g144-3-0",
    mask: "url(#mask120-1-7)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g142-5-9"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path140-9-6",
    style: {
      fill: "url(#linearGradient21257)",
      stroke: "none"
    },
    d: "m 2.492,46.97 c 0.973,1.426 2.395,2.207 4.232,2.32 0.115,0.006 0.227,0.01 0.333,0.01 1.663,0 2.601,-0.82 3.419,-1.659 1.607,-1.645 1.707,-6.122 1.768,-15.423 18.04,-4.051 26.213,1.793 45.277,1.793 11.387,0 8.021,-0.692 15.975,-1.907 0.004,0.244 0.004,0.478 0.006,0.723 0,0 -0.01,1.608 -0.01,2.283 -0.016,5.375 -0.023,10.454 -1.568,10.454 -0.955,0 -1.219,-0.402 -1.693,-1.135 -0.521,-0.8 -1.23,-1.893 -3,-1.893 -2.299,0 -3.275,1.347 -3.275,4.504 -0.002,0.191 -0.074,6.451 -0.105,9.749 0,3.703 -2.949,6.719 -6.572,6.719 H 9.727 c -3.797,0 -7.255,-3.203 -7.255,-6.719 0,0 0.013,-5.811 0.013,-9.332 -10e-4,-0.185 0.003,-0.345 0.007,-0.487"
  }))))))))), /*#__PURE__*/React.createElement("g", {
    id: "g156-31-4"
  }, _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "g158-7-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g170-8-2"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.899994
    },
    id: "g168-3-2",
    clipPath: "url(#clipPath162-8-6)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g166-8-0",
    transform: "translate(2.484,16.991)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path164-7-4",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 0,0 c 0,0.183 0.004,0.343 0.008,0.485 0.973,-1.427 2.396,-2.207 4.232,-2.319 0.115,-0.009 0.227,-0.013 0.333,-0.013 1.663,0 2.601,0.818 3.419,1.66 1.7,1.737 1.713,3.977 1.778,14.711 l -0.005,0.7 C 9.703,5.094 9.654,2.916 7.992,1.214 7.174,0.379 6.237,-0.441 4.574,-0.441 4.468,-0.441 4.356,-0.438 4.241,-0.43 2.405,-0.319 0.981,0.465 0.009,1.889 0.004,1.727 0.001,1.566 0.001,1.404 c 0,-3.521 -0.013,-9.332 -0.013,-9.332 L -0.01,-7.977 C -0.005,-6.05 0,-2.464 0,0 m 7.243,45.112 h 47.546 c 3.623,0 6.572,-3.014 6.572,-6.719 0.032,-3.296 0.104,-9.558 0.106,-9.75 0,-3.154 0.979,-4.504 3.276,-4.504 1.769,0 2.479,1.096 3,1.895 0.476,0.731 0.737,1.135 1.692,1.135 1.545,0 1.554,-5.077 1.567,-10.453 0,-0.393 0.003,-1.102 0.005,-1.625 0,0.252 0,0.491 0.006,0.743 0,0 -0.011,1.608 -0.011,2.283 -0.016,5.375 -0.022,10.454 -1.567,10.454 -0.955,0 -1.219,-0.402 -1.692,-1.135 -0.521,-0.8 -1.231,-1.893 -3,-1.893 -2.299,0 -3.276,1.347 -3.276,4.504 -0.002,0.191 -0.074,6.451 -0.106,9.749 0,3.703 -2.949,6.719 -6.572,6.719 H 7.243 c -3.797,0 -7.255,-3.203 -7.255,-6.719 l 0.002,-1.355 c 0.031,3.497 3.473,6.671 7.253,6.671"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "g172-32-8"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipPath178-1-6)",
    id: "g174-8-3"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(33.6705,28.6385)",
    id: "g180-38-1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path182-85-0",
    style: {
      fill: "#308ba0",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "M 0,0 C -0.876,0 -1.688,0.26 -2.288,0.924 -2.991,1.703 -3.325,2.761 -3.204,3.92 l 0.48,2.586 c 0.056,0.54 -0.063,1.004 -0.325,1.295 -0.158,0.178 -0.388,0.277 -0.626,0.27 -0.043,0 -4.227,-0.27 -4.227,-0.27 -0.146,-0.018 -0.292,-0.027 -0.439,-0.026 -1.674,0 -3.631,1.173 -3.631,4.479 0,3.572 10.471,12.592 13.774,15.348 0.675,0.725 1.569,1.121 2.528,1.121 0.957,0 1.85,-0.396 2.522,-1.115 2.44,-1.97 13.779,-11.337 13.779,-15.354 0,-1.434 -0.326,-2.554 -0.971,-3.33 -0.627,-0.756 -1.523,-1.155 -2.596,-1.155 -0.185,0 -0.373,0.013 -0.563,0.036 l -3.979,0.246 c -0.062,0.008 -0.125,0.013 -0.188,0.014 -0.25,0 -0.46,-0.094 -0.626,-0.276 C 11.446,7.497 11.327,7.02 11.385,6.481 L 11.864,3.868 C 11.982,2.709 11.648,1.705 10.947,0.926 10.352,0.26 9.54,0 8.663,0 Z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(39.8395,55.5145)",
    id: "g184-0-8"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path186-5-0",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 0,0 c -1.011,1.129 -2.664,1.129 -3.674,0 0,0 -13.467,-11.221 -13.467,-14.623 0,-2.549 1.354,-3.66 3.008,-3.457 l 4.037,0.252 c 1.379,0.166 2.367,-1.035 2.197,-2.672 l -0.48,-2.613 c -0.17,-1.637 0.655,-2.763 2.041,-2.763 h 9 c 1.387,0 2.212,1.126 2.042,2.763 L 4.225,-20.5 c -0.17,1.637 0.817,2.838 2.196,2.672 l 4.037,-0.252 c 1.654,-0.203 3.009,0.674 3.009,3.457 C 13.467,-10.846 0,0 0,0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(45.5015,12.6385)",
    id: "g188-4-8"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path190-5-5",
    style: {
      fill: "#308ba0",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 0,0 c 0,-2.209 -1.791,-4 -4,-4 h -8 c -2.209,0 -4,1.791 -4,4 v 1 c 0,2.209 1.791,4 4,4 h 8 C -1.791,5 0,3.209 0,1 Z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(44.5015,12.6385)",
    id: "g192-9-8"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path194-2-4",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 0,0 c 0,-1.657 -1.343,-3 -3,-3 h -8 c -1.657,0 -3,1.343 -3,3 v 1 c 0,1.657 1.343,3 3,3 h 8 C -1.343,4 0,2.657 0,1 Z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(45.5015,22.6385)",
    id: "g196-4-6"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path198-6-9",
    style: {
      fill: "#308ba0",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 0,0 c 0,-2.209 -1.791,-4 -4,-4 h -8 c -2.209,0 -4,1.791 -4,4 v 1 c 0,2.209 1.791,4 4,4 h 8 C -1.791,5 0,3.209 0,1 Z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(44.5015,22.6385)",
    id: "g200-49-9"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path202-6-0",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 0,0 c 0,-1.657 -1.343,-3 -3,-3 h -8 c -1.657,0 -3,1.343 -3,3 v 1 c 0,1.657 1.343,3 3,3 h 8 C -1.343,4 0,2.657 0,1 Z"
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.3023652,0,0,-0.3023652,402.50475,303.27483)",
    id: "g10-7"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g12-4",
    transform: "translate(-0.22394916,0.67184749)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipPath18-7-5)",
    id: "g14-1"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(9.727,0.85)",
    id: "g20-9-5"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path22-4-3",
    style: {
      fill: "#43d3ff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 0,0 c -4.649,0 -8.727,3.838 -8.727,8.212 0,0 0.013,5.81 0.013,9.332 0,1.348 0.13,2.725 1.092,2.725 0.555,0 1.033,-0.544 1.58,-1.36 0.712,-1.062 1.736,-1.622 3.13,-1.71 0.083,-0.005 0.163,-0.008 0.242,-0.008 1.003,0 1.587,0.41 2.375,1.217 1.233,1.264 1.289,3.469 1.352,13.67 -0.063,10.194 -0.119,12.397 -1.352,13.662 -0.788,0.807 -1.372,1.217 -2.375,1.217 -0.078,0 -0.159,-0.003 -0.242,-0.008 -1.393,-0.086 -2.416,-0.645 -3.129,-1.708 -0.547,-0.817 -1.025,-1.362 -1.58,-1.362 -0.962,0 -1.092,1.378 -1.092,2.726 -0.001,3.52 -0.014,9.331 -0.014,9.331 0,4.376 4.078,8.214 8.727,8.214 h 47.546 c 4.435,0 8.041,-3.684 8.041,-8.213 0,0 0.104,-9.542 0.104,-9.749 0,-3.01 0.921,-3.01 1.812,-3.01 0.979,0 1.312,0.513 1.772,1.224 0.522,0.804 1.177,1.804 2.92,1.804 3.011,0 3.021,-4.752 3.039,-11.946 l 0.009,-2.285 -0.009,-2.084 c -0.019,-7.195 -0.028,-11.948 -3.039,-11.948 -1.743,0 -2.396,1.001 -2.92,1.807 -0.462,0.711 -0.796,1.226 -1.772,1.226 -0.891,0 -1.812,0 -1.812,-3.015 0,-0.207 -0.104,-9.752 -0.104,-9.752 C 55.587,3.687 51.981,0 47.546,0 47.546,0 0,0 0,0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(57.273,65.5)",
    id: "g24-4-6"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path26-0-8",
    style: {
      fill: "#308ba0",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 0,0 h -47.546 c -4.915,0 -9.227,-4.071 -9.227,-8.713 0,-0.002 0.013,-5.812 0.013,-9.332 0,-0.965 0,-3.226 1.592,-3.226 0.863,0 1.483,0.818 1.996,1.584 0.395,0.589 1.11,1.385 2.744,1.486 0.073,0.004 0.143,0.007 0.211,0.007 0.835,0 1.297,-0.329 2.018,-1.067 1.097,-1.125 1.148,-3.288 1.209,-13.321 -0.062,-10.023 -0.113,-12.188 -1.21,-13.312 -0.719,-0.734 -1.181,-1.063 -2.017,-1.063 -0.069,0 -0.139,0.002 -0.212,0.007 -1.634,0.1 -2.348,0.897 -2.744,1.487 -0.513,0.766 -1.132,1.582 -1.995,1.582 -0.305,0 -1.05,-0.115 -1.379,-1.188 -0.144,-0.472 -0.213,-1.138 -0.213,-2.037 0,-3.521 -0.013,-9.33 -0.013,-9.33 0,-4.646 4.312,-8.717 9.227,-8.717 H 0 c 4.711,0 8.541,3.908 8.541,8.715 0.004,0.379 0.104,9.537 0.104,9.746 0,2.514 0.552,2.514 1.312,2.514 0.672,0 0.873,-0.256 1.354,-0.997 0.525,-0.81 1.322,-2.033 3.339,-2.033 3.509,0 3.521,4.951 3.539,12.446 0.002,0.674 0.004,1.367 0.009,2.08 v 0.206 c -0.005,0.719 -0.007,1.413 -0.009,2.086 -0.021,7.494 -0.03,12.445 -3.539,12.445 -2.017,0 -2.812,-1.222 -3.339,-2.031 -0.48,-0.74 -0.684,-0.996 -1.354,-0.996 -0.76,0 -1.312,0 -1.312,2.51 0,0.21 -0.103,9.37 -0.104,9.76 C 8.541,-3.909 4.709,0 0,0 m 0,-1 c 4.166,0 7.541,-3.454 7.541,-7.713 0,0 0.104,-9.542 0.104,-9.749 0,-3.113 0.979,-3.51 2.312,-3.51 2.566,0 1.824,3.027 4.691,3.027 2.762,0 2.5,-5.62 2.549,-13.531 v -0.201 c -0.049,-7.909 0.213,-13.532 -2.549,-13.532 -2.867,0 -2.125,3.029 -4.691,3.029 -1.332,0 -2.312,-0.399 -2.312,-3.512 0,-0.207 -0.104,-9.748 -0.104,-9.748 0,-4.263 -3.375,-7.713 -7.541,-7.713 h -47.546 c -4.164,0 -8.227,3.45 -8.227,7.713 0,0 0.013,5.811 0.013,9.332 0,1.685 0.255,2.226 0.592,2.226 0.365,0 0.826,-0.634 1.165,-1.14 0.586,-0.873 1.588,-1.81 3.514,-1.932 0.094,-0.006 0.185,-0.009 0.273,-0.009 1.241,0 1.944,0.562 2.732,1.367 1.385,1.42 1.43,3.54 1.494,14.017 -0.064,10.479 -0.109,12.598 -1.494,14.017 -0.789,0.809 -1.491,1.369 -2.733,1.369 -0.088,0 -0.179,-0.003 -0.273,-0.009 -1.926,-0.119 -2.928,-1.055 -3.514,-1.928 -0.339,-0.507 -0.8,-1.141 -1.165,-1.141 -0.337,0 -0.592,0.542 -0.592,2.226 0,3.521 -0.013,9.332 -0.013,9.332 10e-4,4.259 4.063,7.713 8.228,7.713 L 0,-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g28-7-9"
  }, _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "g30-8"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g96-6-2"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.199997
    },
    id: "g94-9",
    clipPath: "url(#clipPath34-1)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g92-6-6"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g90-07-0",
    clipPath: "url(#clipPath38-8)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g88-2-2"
  }, _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "g80-2-2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g86-0",
    mask: "url(#mask56-2)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g84-2-0"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path82-5-1",
    style: {
      fill: "url(#linearGradient21259)",
      stroke: "none"
    },
    d: "m 9.727,2.341 c -3.797,0 -7.255,3.203 -7.255,6.722 0,0 0.013,5.812 0.013,9.332 0,0.184 0.004,0.342 0.008,0.485 0.973,-1.427 2.396,-2.208 4.232,-2.319 0.115,-0.008 0.227,-0.011 0.333,-0.011 1.663,0 2.601,0.82 3.419,1.658 1.7,1.739 1.713,3.976 1.778,14.709 C 12.19,43.666 12.177,45.901 10.477,47.641 9.658,48.479 8.721,49.3 7.058,49.3 6.952,49.3 6.84,49.296 6.725,49.29 4.887,49.177 3.465,48.395 2.493,46.97 c -0.005,0.162 -0.008,0.323 -0.008,0.485 0,3.521 -0.013,9.332 -0.013,9.332 0,3.516 3.458,6.719 7.255,6.719 h 47.546 c 3.623,0 6.572,-3.016 6.572,-6.719 0.032,-3.298 0.104,-9.558 0.106,-9.749 0,-3.157 0.979,-4.504 3.276,-4.504 1.769,0 2.479,1.093 3,1.893 0.476,0.732 0.737,1.135 1.692,1.135 1.545,0 1.554,-5.079 1.567,-10.454 0,-0.675 0.011,-2.283 0.011,-2.283 -0.008,-0.71 -0.011,-1.409 -0.011,-2.085 -0.016,-5.374 -0.022,-10.453 -1.567,-10.453 -0.955,0 -1.219,0.404 -1.692,1.135 -0.521,0.803 -1.231,1.895 -3,1.895 -2.299,0 -3.276,-1.348 -3.276,-4.506 -0.002,-0.188 -0.074,-6.449 -0.106,-9.734 0,-3.719 -2.949,-6.732 -6.572,-6.732 H 9.727 Z"
  }))))))))), /*#__PURE__*/React.createElement("g", {
    id: "g98-9"
  }, _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "g100-6-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g154-4"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.75
    },
    id: "g152-5-8",
    clipPath: "url(#clipPath104-2)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g150-7"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g148-6-1",
    clipPath: "url(#clipPath108-3)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g146-0"
  }, _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "g138-6-3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g144-8-0",
    mask: "url(#mask120-63)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g142-57"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path140-5",
    style: {
      fill: "url(#linearGradient21261)",
      stroke: "none"
    },
    d: "m 2.492,46.97 c 0.973,1.426 2.395,2.207 4.232,2.32 0.115,0.006 0.227,0.01 0.333,0.01 1.663,0 2.601,-0.82 3.419,-1.659 1.607,-1.645 1.707,-6.122 1.768,-15.423 18.04,-4.051 26.213,1.793 45.277,1.793 11.387,0 8.021,-0.692 15.975,-1.907 0.004,0.244 0.004,0.478 0.006,0.723 0,0 -0.01,1.608 -0.01,2.283 -0.016,5.375 -0.023,10.454 -1.568,10.454 -0.955,0 -1.219,-0.402 -1.693,-1.135 -0.521,-0.8 -1.23,-1.893 -3,-1.893 -2.299,0 -3.275,1.347 -3.275,4.504 -0.002,0.191 -0.074,6.451 -0.105,9.749 0,3.703 -2.949,6.719 -6.572,6.719 H 9.727 c -3.797,0 -7.255,-3.203 -7.255,-6.719 0,0 0.013,-5.811 0.013,-9.332 -10e-4,-0.185 0.003,-0.345 0.007,-0.487"
  }))))))))), /*#__PURE__*/React.createElement("g", {
    id: "g156-6-0"
  }, _g0 || (_g0 = /*#__PURE__*/React.createElement("g", {
    id: "g158-4-0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g170-9-0"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.899994
    },
    id: "g168-9-5",
    clipPath: "url(#clipPath162-00-1)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g166-6",
    transform: "translate(2.484,16.991)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path164-0",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 0,0 c 0,0.183 0.004,0.343 0.008,0.485 0.973,-1.427 2.396,-2.207 4.232,-2.319 0.115,-0.009 0.227,-0.013 0.333,-0.013 1.663,0 2.601,0.818 3.419,1.66 1.7,1.737 1.713,3.977 1.778,14.711 l -0.005,0.7 C 9.703,5.094 9.654,2.916 7.992,1.214 7.174,0.379 6.237,-0.441 4.574,-0.441 4.468,-0.441 4.356,-0.438 4.241,-0.43 2.405,-0.319 0.981,0.465 0.009,1.889 0.004,1.727 0.001,1.566 0.001,1.404 c 0,-3.521 -0.013,-9.332 -0.013,-9.332 L -0.01,-7.977 C -0.005,-6.05 0,-2.464 0,0 m 7.243,45.112 h 47.546 c 3.623,0 6.572,-3.014 6.572,-6.719 0.032,-3.296 0.104,-9.558 0.106,-9.75 0,-3.154 0.979,-4.504 3.276,-4.504 1.769,0 2.479,1.096 3,1.895 0.476,0.731 0.737,1.135 1.692,1.135 1.545,0 1.554,-5.077 1.567,-10.453 0,-0.393 0.003,-1.102 0.005,-1.625 0,0.252 0,0.491 0.006,0.743 0,0 -0.011,1.608 -0.011,2.283 -0.016,5.375 -0.022,10.454 -1.567,10.454 -0.955,0 -1.219,-0.402 -1.692,-1.135 -0.521,-0.8 -1.231,-1.893 -3,-1.893 -2.299,0 -3.276,1.347 -3.276,4.504 -0.002,0.191 -0.074,6.451 -0.106,9.749 0,3.703 -2.949,6.719 -6.572,6.719 H 7.243 c -3.797,0 -7.255,-3.203 -7.255,-6.719 l 0.002,-1.355 c 0.031,3.497 3.473,6.671 7.253,6.671"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "g172-3-4"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipPath178-4)",
    id: "g174-5"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(46.0005,52.5)",
    id: "g180-1-1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path182-81-2",
    style: {
      fill: "#308ba0",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 0,0 c 0,-2.209 -1.791,-4 -4,-4 h -8 c -2.209,0 -4,1.791 -4,4 v 1 c 0,2.209 1.791,4 4,4 h 8 C -1.791,5 0,3.209 0,1 Z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(45.0005,52.5)",
    id: "g184-1-0"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path186-6-8",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 0,0 c 0,-1.657 -1.343,-3 -3,-3 h -8 c -1.657,0 -3,1.343 -3,3 v 1 c 0,1.657 1.343,3 3,3 h 8 C -1.343,4 0,2.657 0,1 Z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(46.0005,42.5)",
    id: "g188-0-5"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path190-60-6",
    style: {
      fill: "#308ba0",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 0,0 c 0,-2.209 -1.791,-4 -4,-4 h -8 c -2.209,0 -4,1.791 -4,4 v 1 c 0,2.209 1.791,4 4,4 h 8 C -1.791,5 0,3.209 0,1 Z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(45.0005,42.5)",
    id: "g192-4-0"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path194-11-9",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 0,0 c 0,-1.657 -1.343,-3 -3,-3 h -8 c -1.657,0 -3,1.343 -3,3 v 1 c 0,1.657 1.343,3 3,3 h 8 C -1.343,4 0,2.657 0,1 Z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(42.3345,37.223)",
    id: "g196-6-7"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path198-9-0",
    style: {
      fill: "#308ba0",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 0,0 c 0.877,0 1.689,-0.26 2.284,-0.926 0.7,-0.779 1.034,-1.783 0.917,-2.942 L 2.722,-6.48 c -0.059,-0.539 0.061,-1.017 0.322,-1.309 0.158,-0.179 0.387,-0.28 0.626,-0.275 0.042,0 0.085,0.002 0.188,0.014 l 3.979,0.246 c 0.189,0.022 0.378,0.035 0.562,0.035 1.074,0 1.97,-0.398 2.597,-1.154 0.646,-0.776 0.971,-1.896 0.971,-3.33 0,-4.018 -11.339,-13.385 -13.778,-15.354 -0.672,-0.72 -1.565,-1.116 -2.522,-1.116 -0.959,0 -1.854,0.396 -2.528,1.121 -3.303,2.756 -13.775,11.775 -13.775,15.348 0,3.306 1.957,4.479 3.632,4.479 0.164,0 0.33,-0.01 0.438,-0.025 0,0 4.185,-0.27 4.228,-0.27 0.25,0 0.461,0.086 0.626,0.27 0.262,0.291 0.381,0.755 0.324,1.295 l -0.479,2.586 c -0.121,1.159 0.213,2.217 0.916,2.996 0.6,0.664 1.412,0.924 2.288,0.924 H 0 Z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(53.3065,24.97)",
    id: "g200-0-4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path202-47-5",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "M 0,0 C 0,2.783 -1.354,3.66 -3.009,3.457 L -7.046,3.205 C -8.425,3.039 -9.412,4.239 -9.242,5.877 l 0.479,2.612 c 0.17,1.638 -0.655,2.764 -2.042,2.764 h -9 c -1.387,0 -2.211,-1.126 -2.041,-2.764 l 0.479,-2.612 c 0.17,-1.638 -0.817,-2.838 -2.196,-2.672 L -27.6,3.457 C -29.254,3.66 -30.608,2.549 -30.608,0 c 0,-3.402 13.468,-14.623 13.468,-14.623 1.01,-1.129 2.663,-1.129 3.674,0 C -13.466,-14.623 0,-3.778 0,0"
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDown);
export default __webpack_public_path__ + "static/media/down.bc05e6953db84a16164e92021f47374c.svg";
export { ForwardRef as ReactComponent };